import { createAction } from "@reduxjs/toolkit";

export const environmentActionTypes = {
  initEnvironment: "environment/init",
};

export const environmentActions = {
  initEnvironment: createAction(environmentActionTypes.initEnvironment),
};
